// extracted by css-extract-rspack-plugin
export default {"icon-button-wrapper":"OcHkBF","iconButtonWrapper":"OcHkBF","number":"eMD0xp"};